import { render, staticRenderFns } from "./ApprovalApplicationHistory.vue?vue&type=template&id=021b705d"
import script from "./ApprovalApplicationHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalApplicationHistory.vue?vue&type=script&lang=js"
import style0 from "./ApprovalApplicationHistory.vue?vue&type=style&index=0&id=021b705d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports